module.exports = {
  ShanghaiPort: 'Shanghai Port',
  QingdaoPort: 'Qingdao Port',
  DeletionGuide: 'Deletion Guide',
  BusinessData: 'Business Data',
  DropOffGoods: 'Drop-Off Goods',
  CounterDeletion: 'Counter Deletion',
  CertificateOfNonBoarding: 'Certificate of Non-Boarding',
  CarrierName: 'Carrier Name',
  Text1: 'Service Range (Platform supports',
  Text2: 'shipping companies and',
  Text3: 'carriers. The list is as follows:)',
  Text4: 'Guide on Handling "Pre-Allocation Manifest Changes or Deletions"',
  Title1: 'Service scope - The platform support',
  Title2: 'shipping companies, with the following list:',
  Remark1: 'Shanghai Zhenhua (Carrier)',
  Remark2: 'Dongjin DJS, Antong ONTO, Datong EAS, Fan Zhou PCS prohibited',
  Remark3: 'Shanghai Minsheng (Carrier)',
  Remark4: 'Minsheng shipping company’s Taiwan and Japan lines prohibited. Wan Hai WHL’s Taiwan line allowed',
  Remark5: 'Jincheng (Carrier)',
  Remark6: 'Jinjiang Shipping JJ prohibited',
  Remark7: 'Zhengli (Carrier)',
  Remark8: '"CNC-Zhengli" Taiwan line, choose "CST-Bao Hua" as carrier code',
  Remark9: 'Xindong (Carrier)',
  Remark10: '"NOS-Xindong" Incheon, Korea line, choose "NSI-Ningbo Ocean" as carrier code',
  Remark11: 'Singapore Shipping (Carrier)',
  Remark12: 'Sub-brand of Bianhang shipping company, bills of lading starting with SEC allowed, select "SCO-Singapore Shipping" as the carrier',
  Remark13: 'Singapore Sea Link Shipping (Carrier)',
  Remark14: 'FCSL-UAE Volta is represented by VOLTA in Shanghai, select "SLS-Singapore Sea Link Shipping" as the carrier',
  Remark15: 'Shanghai Zhonglian (Carrier)',
  Remark16: 'Zhonglian CUL, Rizhao Port RPS prohibited',
  Remark17: 'Before departure, if it has not exceeded the manifest deadline set by the carrier and the entire batch has not been declared:',
  Remark18: 'a) If you need to change the shipping company, carrier, bill of lading number, vessel name, voyage, container number, seal number, commodity name, container type: select the original manifest in "Sent", submit a deletion request, and after completion, resubmit the new manifest. Container type errors must be deleted for Zhonglian/OOCL/Sinotrans/Zhenhua, others can be directly modified.',
  Remark19: 'b) If you need to change information other than the 9 categories above, select the manifest in "Sent", submit a modification request, and wait for the receipt.',
  Remark20: 'c) For consolidated shipments (LCL):',
  Remark21: 'i) If you need to modify one or several shipments, refer to point b above.',
  Remark22: 'ii) If you need to delete one or several shipments, delete all manifests under the same container number, then resend the new manifests.',
  Remark23: 'iii) If you need to add one shipment, directly send the consolidated shipment (if the carrier is Hanhua or Penghua, the sub-bill number must be sent with the main bill).',
  Remark24: 'Before departure, but after the manifest deadline set by the carrier, or if the customer has declared:',
  Remark25: 'a) If the customer has declared, the declaration must be canceled first.',
  Remark26: 'b) Specifically consult the corresponding carrier on how to handle deletions and modifications (specifically, ask our customer service).',
  Remark27: 'c) If it has been released, paper documents must be submitted to the carrier’s counter to cancel the "released" mark (specifically, ask our customer service).',
  Remark28: 'After departure, apply for deletion:',
  Remark29: 'a) If the customer has declared, the declaration must be canceled first.',
  Remark30: 'b) Paper documents must be submitted to the carrier’s counter for deletion: generally, at least the following 4 materials are required (for reference only): "Deletion Application", "Declaration Form", "Deletion Explanation", and "Screenshot of the Transfer Status on the Customs Information Network" (we can provide agency services, specifically ask customer service).',
  Remark31: 'Attached: Addresses of various carrier counters',
  CompanyName1: 'Shanghai Waigaoqiao',
  CompanyName2: 'Shanghai Sinotrans',
  CompanyName3: 'Shanghai United',
  CompanyName4: 'Shanghai Huagang',
  CompanyName5: 'Shanghai Shunde',
  CompanyName6: 'Shanghai Hanhua',
  CompanyName7: 'Shanghai Minsheng',
  CompanyName8: 'Shanghai Penghua',
  CompanyName9: 'Shanghai Penghai',
  CompanyName10: 'Shanghai Zhonglian (Zhonghe)',
  CompanyName11: 'Shanghai Zhenhua',
  CompanyName12: 'Xinhai',
  CompanyName13: 'Jincheng',
  CompanyName14: 'OOCL',
  CompanyName15: 'Shanghai Port United',
  CompanyName16: 'Shanghai Zhonglian',
  CompanyName17: 'Penghua',
  CompanyAddress1: '5th Floor, 531 Wusong Road, Hongkou District',
  CompanyAddress2: '3rd Floor Hall, 188 Fujian Middle Road',
  CompanyAddress3: '1st Floor, 916 Dongdaming Road, Hongkou District',
  CompanyAddress4: 'Room 1601, 501 Dongdaming Road',
  CompanyAddress5: 'Room 2701, 440 Hailun Road',
  CompanyAddress6: '2nd Floor, 99 Huangpu Road, Hongkou District',
  CompanyAddress7: '16th Floor, Jinfeng International Wealth Plaza, 1619 Dalian Road',
  CompanyAddress8: '5th Floor, Building 1, Zhongtian Building, 1063 Siping Road, Yangpu District, Rooms 501, 502, 508',
  CompanyAddress9: 'Rooms 1807-1809, 700 Yanan East Road',
  CompanyAddress10: '24th Floor, 908 Dongdaming Road, Hongkou District',
  CompanyAddress11: '21st Floor, Gangtai Plaza, 700 Yanan East Road',
  CompanyAddress12: '8th Floor, Shanghai Jahwa Financial Building, 133 Tiantong Road, Hongkou District',
  CompanyAddress13: '8th Floor, 1200 Yanan East Road',
  CompanyAddress14: '20th Floor, 841 Yanan Middle Road'
}
